var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlapping-headline"},[_c('div',{staticClass:"headline--top",class:_vm.topColor},[_vm._v(_vm._s(_vm.topText))]),_c('div',{staticClass:"headline--bottom",class:_vm.bottomColor},[_vm._v(_vm._s(_vm.bottomText))])])}
var staticRenderFns = []

export { render, staticRenderFns }